import React,{ useContext, useState, useEffect } from 'react'
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { capitalize, ErrorWrapper } from './ModalSignUp';
import MyAuthContext from "../context/AuthContext";
import SuccessAlert from './SuccessAlert';
import Loading from './Loading';
import WOW from 'wowjs';

const Contact = () => {
    useEffect(() => {
        new WOW.WOW({
          live: false
        }).init();
      }, [])

    const { sendEmailContact, error, setError, loading } = useContext(MyAuthContext);
    const[successAlert, setSuccessAlert] = useState(null);

    const style = {
        contactInput: "block p-3 w-full text-sm text-gray-700 bg-gray-50 rounded-lg border-2 border-green-500 shadow-sm",
        contactLabel: "block mb-2 text-sm font-medium text-white"
    }

    const schema = yup.object().shape({
        userName:yup.string().required("El nombre es requerido").matches(/^[a-zA-Z ]+$/, "El nombre no debe contener caracteres especiales").max(50, "Nombre demasiado largo").min(1).trim().transform((currentValue) => capitalize(currentValue)),
        userEmail: yup.string().email("El correo es inválido").required("El correo es requerido"),
        userPhone:yup.string().required("El numero de telefono es requerido ").min(8, "El numero de telefono es invalido").max(10),
        userDocument: yup.string().required("El numero de documento es requerido").min(6, "El numero de documento es invalido").max(12),
        userSubject: yup.string().required("El asunto es requerido").matches(/^[a-zA-Z ]+$/, "El asunto no debe contener caracteres especiales").max(120, "Asunto demasiado largo").min(1).trim(),
        userMessage: yup.string().required("El mensaje es requerido")/*.matches(/^[a-zA-Z \n]+$/, "El nombre no debe contener caracteres especiales")*/.max(640, "Te has excedido").min(15, "El mensaje tiene pocas palabras").trim().transform((text) => { text = text.replace(/\n{3,}/g, '\n\n');text = text.replace(/ +/g, ' ');return text}),
    })

    const { handleSubmit, control, register, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    const onSubmit = async (data) => {
        const res = await sendEmailContact(data);
        if (res.error) {
            setError({ "error": true, "message": res.response })
            setTimeout(() => {
                setError({ "error": false, "message": "" })
            }, 5000);
        } else {
            setSuccessAlert("¡Gracias por contactarnos! Te responderemos lo más pronto posible.")
            reset()
            setError({ "error": false, "message": "" })
            setTimeout(() => {
                setSuccessAlert(null)

            }, 5000);
        }
    }

    return (
        <div className="px-8 mx-auto w-full flex lg:flex-row  flex-col items-center mb-10">
            <SuccessAlert isVisible={successAlert} />
            <p className="my-8 px-4 font-mono font-semibold w-[100%] mr-3 text-center text-gray-700 lg:text-4xl sm:text-xl wow animate__animated animate__fadeInUp animate__slow">¿Tienes un problema técnico? ¿Quieres enviar comentarios sobre una función? ¿Necesitas detalles sobre nuestra Dirección? Haznos saber.</p>

            <div className='flex p-8 flex-col w-full lg:w-[900px] m-2 mx-auto sm:w-[500px] bg-gray-700 shadow-xl wow animate__animated 2sm:animate__fadeInRight animate__fadeInUp animate__slow'>
                <form onSubmit={handleSubmit(onSubmit)} class="mx-auto w-full ">
                    <div className=' space-y-4 mx-auto flex flex-col'>
                        <div className='mx-auto w-[95%]'>
                            <label class={style.contactLabel}>Nombre completo*</label>
                            <input {...register("userName")} class={style.contactInput} placeholder="Ej: Pepito Fernandez"></input>
                            <ErrorWrapper error={errors.userName?.message}/>
                        </div>
                        <div className='mx-auto w-[95%] '>
                            <label class={style.contactLabel}>Correo*</label>
                            <input {...register("userEmail")} class={style.contactInput} placeholder="Ej: correo@email.com"></input>
                            <ErrorWrapper error={errors.userEmail?.message}/>
                        </div>
                        <div className='mx-auto w-[95%]'>
                            <label class={style.contactLabel}>Teléfono*</label>
                            <Controller
                                        name="userPhone"
                                        control={control}
                                        defaultValue=""
                                        render={({ field: { value, onChange, ...field } }) => (
                                            <input type="tel" pattern="[0-9]{0,10}" class={style.contactInput} placeholder="Ej: 3228789180"
                                                {...field}
                                                onChange={({ target: { value, validity } }) => {
                                                    const isValid = validity.valid
                                                    if (isValid) {
                                                        onChange(value);
                                                    }
                                                }
                                                }
                                                value={value}
                                            />
                                        )}
                                    />
                            <ErrorWrapper error={errors.userPhone?.message}/>
                        </div>
                        <div class="mx-auto w-[95%]">
                                    <label class={style.contactLabel}>Documento de identidad*</label>
                                    <Controller
                                        name="userDocument"
                                        control={control}
                                        defaultValue=""
                                        render={({ field: { value, onChange, ...field } }) => (
                                            <input type="text" pattern="[0-9]{0,12}" class={style.contactInput} placeholder="000000000 "
                                                {...field}
                                                onChange={({ target: { value, validity } }) => {
                                                    const isValid = validity.valid
                                                    if (isValid) {
                                                        onChange(value);
                                                    }
                                                }
                                                }
                                                value={value}
                                            />
                                        )}
                                    />
                                    <ErrorWrapper error={errors.userDocument?.message} />
                                </div>
                        <div className='mx-auto w-[95%]'>
                            <label class={style.contactLabel}>Asunto*</label>
                            <input {...register("userSubject")} class={style.contactInput} placeholder="Ej: Reclamo... "></input>
                            <ErrorWrapper error={errors.userSubject?.message}/>
                        </div>
                        <div className='mx-auto w-[95%]'>
                            <label class={style.contactLabel}>Mensaje*</label>
                            <textarea {...register("userMessage")} rows="6" class={style.contactInput} placeholder="Deja un comentario..."></textarea>
                            <ErrorWrapper error={errors.userMessage?.message}/>
                        </div>
                        <div className='w-[95%] mx-auto flex flex-col'> 
                        <span className="text-white text-sm mb-2">Al hacer click en "Enviar mensaje" aceptas nuestra <a target="_blank" href="https://www.alcaldianeiva.gov.co/Paginas/Politicas-de-Privacidad-y-Condiciones-de-Uso.aspx" class="text-green-300 hover:text-green-600">Politica de Privacidad, Tratamiento de datos personales y Condiciones de uso.</a></span>
                        {loading ? <Loading isLoading={loading} /> : <button class="py-3 px-5 text-sm font-medium text-center text-white rounded-lg bg-green-600 sm:w-fit focus:ring-4 focus:outline-none focus:ring-primary-300 float-right ">Enviar Mensaje</button>}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
export default Contact;